// import { Services } from '@/interfaces'
import { IDocumentos, IOCRResultParsed, OCR, StorageDocumentos } from '@/interfaces'
import { DocumentosService } from '@/services/DocumentoService'
import { ConvertFile } from '@/utils'
import { PropType } from 'vue'
import { Vue, Component, Prop } from 'vue-property-decorator'
import {
	VBtn,
	VCard,
	VCardActions,
	VCardText,
	VCardTitle,
	VChip,
	VCol,
	VDivider,
	VForm,
	VIcon,
	VLayout,
	VProgressLinear,
	VRow,
	VSimpleTable
} from 'vuetify/lib'
import { DOCUMENTO_OCR_CATEGORIA, getCategoriaDocumentoIdByTipo, documentFilter, StorageDocumentoTopicos } from '@/types'

import './Documentos.scss'
import { OCRResultParsed } from '@/models'

@Component({})
export default class DocumentExtract extends Vue {
	@Prop({ type: Array as PropType<Array<string>>, required: false }) documentosElegiveisProp!: Array<IDocumentos.IDocumentoElegivel>
	@Prop({ type: Object as PropType<IOCRResultParsed>, required: true }) resultadoOcrParsedProp!: IOCRResultParsed
	@Prop({ type: Array as PropType<Array<StorageDocumentos>>, required: false }) documentsAlreadyUploaded!: Array<StorageDocumentos>

	documentosElegiveisList: Array<IDocumentos.IDocumentoElegivel> = new Array()
	resultadoOcrParsed: IOCRResultParsed = new OCRResultParsed({} as IOCRResultParsed)

	solicitacao = {} as IDocumentos.IDocumentoSolicitacao
	errorBucket = new Array<string>()
	form = false
	tiposDocumentos = new Array<IDocumentos.IAttaTipoDocumentosItem>()
	arquivos = {} as FileList
	tempFiles = new Array<IDocumentos.IDocumentoListItem>()
	isLoading = false
	uploadCompleted = false
	droparea = {
		isActive: false
	}

	beforeMount() {
		if (!this.documentosElegiveisProp || this.documentosElegiveisProp.length == 0) {
			this.documentosElegiveisList = [
				{
					text: 'Documento Pessoal (RG, CNH, CPF, RNE)',
					ocrResultList: new Array<OCR.IResult>(),
					categoria: DOCUMENTO_OCR_CATEGORIA.DOCUMENTO_PESSOAL.id,
					qtdDocs: 0
				},
				{
					text: 'Comprovante de residência',
					ocrResultList: new Array<OCR.IResult>(),
					categoria: DOCUMENTO_OCR_CATEGORIA.COMPROVANTE_RESIDENCIA.id,
					qtdDocs: 0
				},
				{
					text: 'Holerite',
					ocrResultList: new Array<OCR.IResult>(),
					categoria: DOCUMENTO_OCR_CATEGORIA.HOLERITE.id,
					qtdDocs: 0
				}
			]
		} else this.documentosElegiveisList = this.documentosElegiveisProp

		this.resultadoOcrParsed = this.resultadoOcrParsedProp

		if (this.documentsAlreadyUploaded) {
			this.documentsAlreadyUploaded.map((eachDoc) => {
				this.tempFiles.push({
					isLoading: false,
					isValid: true,
					tipoDocumento: eachDoc.tipoDocumento,
					quantidade: 1,
					isUploaded: true,
					isCategorized: true,
					isUploading: false,
					progress: 100,
					fileName: eachDoc.nomeArquivo ? eachDoc.nomeArquivo : eachDoc.documento,
					tipo: eachDoc.tipoDocumento.toString(),
					isExtracted: true
				} as IDocumentos.IDocumentoListItem)

				this.documentosElegiveisList.map((eachDocElegivel) => {
					if (documentFilter(eachDoc.tipoDocumento) == eachDocElegivel.categoria) eachDocElegivel.qtdDocs++
				})
			})
		}
	}

	render() {
		return (
			<VLayout class="app-documentos py-4">
				{!this.uploadCompleted && (
					<VForm ref="form" vModel={this.form} onSubmit={this.enviarArquivos}>
						<VRow align="stretch">
							<VCol cols="12" sm={this.$vuetify.breakpoint.width < 1366 ? '12' : '4'} class="flex-grow-1">
								<VCard tile height="240" outlined>
									<div ref="dropzone" class={{ 'text-center px-5 pt-3': true, 'is-active grey lighten-2': this.droparea.isActive }}>
										<VIcon size="72" color="#f2f2f2" class="material-icons-outlined">
											cloud_upload
										</VIcon>
										<VCardText class="mt-4 py-0 text-subtitle">
											Arraste e solte os documentos aqui
											<br />
											ou
										</VCardText>
										<VBtn class="my-2" small loading={this.isLoading} color="primary" outlined onClick={this.handleUploadClick}>
											Clique para selecionar
										</VBtn>
										<input data-cy="upload" ref="upload" accept="image/*, .pdf" multiple onChange={this.previewFiles} type="file" hidden />
										<br />
										<span class="text-obs">Se possivel envie os documentos em preto e branco*</span>
									</div>
								</VCard>
							</VCol>

							<VCol cols="12" sm={this.$vuetify.breakpoint.width < 1366 ? '12' : '4'} class="flex-grow-1">
								<VCard tile height="240" outlined>
									<VCardTitle>Documentos Anexados</VCardTitle>
									<VSimpleTable class="table-layout-fixed pt-2 ml-2" height="142">
										{this.tempFiles && this.tempFiles.length > 0 ? (
											<tbody>{this.tempFiles.map(this.renderDocItem)}</tbody>
										) : (
											<div class="text-center mt-3">
												<VIcon size="72" class="material-icons" color="#f2f2f2">
													error
												</VIcon>
												<VCardText class="mx-auto text-subtitle">Nenhum documento foi anexado...</VCardText>
											</div>
										)}
									</VSimpleTable>
									<VCardActions class="py-0 justify-end">
										<VBtn
											small
											disabled={this.tempFiles.length == 0 || !this.missingFileExtract}
											type="submit"
											loading={this.isLoading}
											outlined
											class="mr-4 px-6 py-4 mb-2"
											color="primary"
										>
											Validar
										</VBtn>
									</VCardActions>
								</VCard>
							</VCol>

							<VCol cols="12" sm={this.$vuetify.breakpoint.width < 1366 ? '12' : '4'} class="flex-grow-1">
								<VCard height="240" outlined tile>
									<VCardTitle>Documentos Elegíveis</VCardTitle>
									<VCardText class="pt-4 px-0">
										{this.documentosElegiveisList.map((eachDocumento, indexDocumento) => (
											<VRow class="px-2">
												<VCol cols="12" class="d-flex align-items-center px-4">
													{eachDocumento.qtdDocs > 0 ? (
														<VChip color="secondary" text-color="#0b5c11" class="ml-1 rounded-pill" key={indexDocumento}>
															1/1
														</VChip>
													) : (
														<VChip color="f6f6f6" text-color="#4d4d4d" class="ml-1 rounded-pill" key={indexDocumento}>
															0/1
														</VChip>
													)}

													<span class="text-subtitle align-center pt-2 ml-3 text-truncate">{eachDocumento.text}</span>
												</VCol>

												{indexDocumento + 1 < this.documentosElegiveisList.length && (
													<VCol class="ma-1 pa-0">
														<VDivider class="my-0" />
													</VCol>
												)}
											</VRow>
										))}
									</VCardText>
								</VCard>
							</VCol>
						</VRow>
					</VForm>
				)}
			</VLayout>
		)
	}

	private renderDocItem(document: IDocumentos.IDocumentoListItem) {
		return (
			<div class="px-3">
				<VRow>
					<VCol cols="10">
						<VChip
							small
							class="doc-attached-chip"
							text-color={document.isExtracted ? '#0b5c11' : '#4d4d4d'}
							color={document.isExtracted ? '#E3F3E4' : '#f6f6f6'}
						>
							<span class="text-truncate font-weight-medium">{this.getDocumentName(document)}</span>
						</VChip>
					</VCol>
					<VCol cols="2" class="text-right">
						{!document.isUploaded && (
							<VBtn icon onClick={() => this.removeFile(document)}>
								<VIcon>delete</VIcon>
							</VBtn>
						)}
					</VCol>
				</VRow>

				{document.isLoading && (
					<div class="text-caption pl-2">
						<span class="font-weight-bold">{document.isUploading ? 'Enviando' : 'Processando'}</span>
					</div>
				)}

				{document.isLoading && document.progress < 100 && (
					<VProgressLinear
						buffer-value={document.progress < 100 ? document.progress : 100}
						color="success"
						value={document.progress == 100 ? document.progress : 0}
						stream
					/>
				)}

				{document.isLoading && document.progress == 100 && <VProgressLinear buffer-value="0" color="success" stream />}
			</div>
		)
	}

	async mounted() {
		await this.init()
	}

	get isMobile() {
		let check = false
		;(function (a) {
			if (
				/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
					a
				) ||
				/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
					a.substr(0, 4)
				)
			)
				check = true
		})(navigator.userAgent || navigator.vendor)
		return check
	}

	async init() {
		if (!this.isMobile) {
			var dropzone = this.$refs.dropzone as HTMLElement
			;['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
				dropzone.addEventListener(
					eventName,
					(e) => {
						e.preventDefault()
						e.stopPropagation()
					},
					false
				)
			})
			;['dragenter', 'dragover'].forEach((eventName) => {
				dropzone.addEventListener(
					eventName,
					() => {
						this.droparea.isActive = true
					},
					false
				)
			})
			;['dragleave', 'drop'].forEach((eventName) => {
				dropzone.addEventListener(
					eventName,
					() => {
						this.droparea.isActive = false
					},
					false
				)
			})

			dropzone.addEventListener('dragenter', (e) => {}, false)

			dropzone.addEventListener('dragleave', (e) => {}, false)

			dropzone.addEventListener('dragover', (e) => {}, false)

			dropzone.addEventListener(
				'drop',
				(e) => {
					this.errorBucket = []
					let dt = e.dataTransfer

					if (dt) {
						let files = Array.from(dt.files).map(
							(file) =>
								({
									file: file,
									tipoDocumento: 0,
									isValid: false,
									isUploaded: false,
									isCategorized: false,
									isLoading: false,
									isUploading: false,
									isExtracted: false,
									progress: 0
								} as IDocumentos.IDocumentoListItem)
						)

						this.tempFiles = this.tempFiles.concat(files)
						this.arquivos = {} as FileList
					}
				},
				false
			)
		}
	}

	handleUploadClick() {
		let el = this.$refs.upload as any
		el.click()
	}

	async enviarArquivos(e: Event) {
		e.preventDefault()

		var element = this.$refs.form as any

		if (element.validate()) {
			this.isLoading = true
			for (let documentListItem of this.tempFiles.filter((u) => !u.isExtracted)) {
				documentListItem.isLoading = true
				documentListItem.isUploading = true

				let fileB64 = await ConvertFile.toBase64(documentListItem.file)
				fileB64 = ConvertFile.clearMeta(fileB64)

				let response: OCR.IResult = await DocumentosService.OCR(fileB64)

				if (response) {
					documentListItem.tipo = response.type

					try {
						response.fileName = documentListItem.file.name
						this.setFieldsOcr(documentListItem.tipo, response)
						documentListItem.isValid = true
					} catch (error) {
						console.log('Erro ao preencher o objeto', error)
						documentListItem.isValid = false
					}
				} else {
					console.log('Sem response', response)
					documentListItem.isValid = false
				}

				documentListItem.isExtracted = true

				documentListItem.isLoading = false
				documentListItem.isUploading = false
			}

			this.setOcrResults()
			this.$emit('atualizarOCR', this.resultadoOcrParsed)

			this.isLoading = false
		}
	}

	previewFiles(event: any) {
		const filesList = Array.from(event.target.files).map(
			(file) =>
				({
					file: file,
					tipoDocumento: 0,
					isValid: false,
					isUploaded: false,
					isCategorized: false,
					isLoading: false,
					isUploading: false,
					isExtracted: false,
					progress: 0
				} as IDocumentos.IDocumentoListItem)
		)

		this.tempFiles = this.tempFiles.concat(filesList)
		this.arquivos = {} as FileList

		//When trying to select a file that has already selected before, it doesn't work because browser always store value path 'C:\fakepath' for security.
		//Then onChange event is not triggered
		//Reset value to always trigger onChange
		event.target.value = ''
	}

	removeFile(document: IDocumentos.IDocumentoListItem) {
		if (document.isLoading || document.isUploaded) return

		let fileIndex = this.tempFiles.findIndex((u) => u.file && u.file.name == this.getDocumentName(document))
		this.tempFiles.splice(fileIndex, 1)

		this.documentosElegiveisList.forEach((eachDocumentoElegivel) => {
			if (eachDocumentoElegivel.ocrResultList) {
				let ocrResultIndex = eachDocumentoElegivel.ocrResultList.findIndex(
					(ocrResult) => ocrResult.fileName == this.getDocumentName(document)
				)

				if (ocrResultIndex != -1) eachDocumentoElegivel.ocrResultList.splice(ocrResultIndex, 1)
			}
		})
	}

	get missingFileExtract(): boolean {
		if (this.tempFiles.filter((tmpFile) => tmpFile.isExtracted == false).length > 0) return true

		return false
	}

	setFieldsOcr(documentTypeResult: string, ocrResult: OCR.IResult): void {
		let typeFixed = getCategoriaDocumentoIdByTipo(documentTypeResult)
		if (typeFixed) {
			this.documentosElegiveisList.map((eachDocumento) => {
				if (eachDocumento.categoria == typeFixed) {
					if (!eachDocumento.ocrResultList) eachDocumento.ocrResultList = new Array<OCR.IResult>()

					eachDocumento.ocrResultList.push(ocrResult)
					eachDocumento.qtdDocs++
				}
			})
		}
	}

	setOcrResults(): void {
		this.resultadoOcrParsed = new OCRResultParsed({} as IOCRResultParsed)

		let hasDocumentoPessoal = this.documentosElegiveisList.some(
			(eachDocumento) =>
				eachDocumento.categoria == DOCUMENTO_OCR_CATEGORIA.DOCUMENTO_PESSOAL.id &&
				eachDocumento.ocrResultList &&
				eachDocumento.ocrResultList.length > 0
		)
		let hasComprovanteResidencia = this.documentosElegiveisList.some(
			(eachDocumento) =>
				eachDocumento.categoria == DOCUMENTO_OCR_CATEGORIA.COMPROVANTE_RESIDENCIA.id &&
				eachDocumento.ocrResultList &&
				eachDocumento.ocrResultList.length > 0
		)
		let hasHolerite = this.documentosElegiveisList.some(
			(eachDocumento) =>
				eachDocumento.categoria == DOCUMENTO_OCR_CATEGORIA.HOLERITE.id &&
				eachDocumento.ocrResultList &&
				eachDocumento.ocrResultList.length > 0
		)

		let currentFieldListCombined: Array<OCR.IField>
		let currentTagListCombined: Array<string>
		this.documentosElegiveisList
			.filter((eachDocumento) => eachDocumento.ocrResultList && eachDocumento.ocrResultList.length > 0)
			.forEach((eachDocumento) => {
				try {
					currentFieldListCombined = new Array<OCR.IField>()
					currentTagListCombined = new Array<string>()

					eachDocumento.ocrResultList?.forEach((eachResult) => {
						currentFieldListCombined = currentFieldListCombined.concat(eachResult.fields)
						currentTagListCombined = currentTagListCombined.concat(eachResult.tags)
					})

					//'nome' é um termo generico, entao pode vir para diferentes tipos de valores (nome da empresa, nome documento, nome orgao responsavel, etc)
					if (hasDocumentoPessoal && eachDocumento.categoria == DOCUMENTO_OCR_CATEGORIA.DOCUMENTO_PESSOAL.id) {
						this.resultadoOcrParsed.nome = this.searchAndFillResults(this.resultadoOcrParsed.nome, 'nome', currentFieldListCombined)
					} else if (!hasDocumentoPessoal)
						//Problema, como 'nome' é um termo muito generico, podem vir dados 'estranhos'. Ja foi avisado
						this.resultadoOcrParsed.nome = this.searchAndFillResults(this.resultadoOcrParsed.nome, 'nome', currentFieldListCombined)

					this.resultadoOcrParsed.cpf = this.searchAndFillResults(this.resultadoOcrParsed.cpf, 'cpf', currentFieldListCombined)
					this.resultadoOcrParsed.dataNascimento = this.searchAndFillResults(
						this.resultadoOcrParsed.dataNascimento,
						'data_nascimento',
						currentFieldListCombined
					)
					//Se nao vier na 'filiacao_1', tentar a 'filiacao_2'
					this.resultadoOcrParsed.nomeMae = this.searchAndFillResults(
						this.resultadoOcrParsed.nomeMae,
						'filiacao_1',
						currentFieldListCombined
					)
					this.resultadoOcrParsed.nomeMae = this.searchAndFillResults(
						this.resultadoOcrParsed.nomeMae,
						'filiacao_2',
						currentFieldListCombined
					)

					if (eachDocumento.categoria == DOCUMENTO_OCR_CATEGORIA.DOCUMENTO_PESSOAL.id) {
						//Preenche o numero do documento e o tipo
						this.fillDocumentoPessoalValue(currentTagListCombined, currentFieldListCombined)
					}

					this.resultadoOcrParsed.cep = this.searchAndFillResults(this.resultadoOcrParsed.cep, 'cep', currentFieldListCombined)
					this.resultadoOcrParsed.enderecoUF = this.searchAndFillResults(
						this.resultadoOcrParsed.enderecoUF,
						'cep_uf',
						currentFieldListCombined
					)
					this.resultadoOcrParsed.cidade = this.searchAndFillResults(this.resultadoOcrParsed.cidade, 'cep_cidade', currentFieldListCombined)
					this.resultadoOcrParsed.bairro = this.searchAndFillResults(this.resultadoOcrParsed.bairro, 'cep_bairro', currentFieldListCombined)
					this.resultadoOcrParsed.endereco = this.searchAndFillResults(
						this.resultadoOcrParsed.endereco,
						'cep_logradouro',
						currentFieldListCombined
					)
					this.resultadoOcrParsed.enderecoComplemento = this.searchAndFillResults(
						this.resultadoOcrParsed.enderecoComplemento,
						'complemento',
						currentFieldListCombined,
						true
					)
					this.fillNumeroCasa(currentFieldListCombined) //Esse campo não é tao 'seguro' de conseguir

					this.resultadoOcrParsed.nacionalidade = this.searchAndFillResults(
						this.resultadoOcrParsed.nacionalidade,
						'nacionalidade',
						currentFieldListCombined,
						true
					)

					this.resultadoOcrParsed.empresaNome = this.searchAndFillResults(
						this.resultadoOcrParsed.empresaNome,
						'nome_empregador',
						currentFieldListCombined
					)
					this.resultadoOcrParsed.empresaNome = this.searchAndFillResults(
						this.resultadoOcrParsed.empresaNome,
						'nome_empresa',
						currentFieldListCombined
					)

					this.resultadoOcrParsed.profissao = this.searchAndFillResults(
						this.resultadoOcrParsed.profissao,
						'profissao',
						currentFieldListCombined
					)
					this.resultadoOcrParsed.cargo = this.searchAndFillResults(this.resultadoOcrParsed.cargo, 'cargo', currentFieldListCombined)

					this.resultadoOcrParsed.dataAdmissao = this.searchAndFillResults(
						this.resultadoOcrParsed.dataAdmissao,
						'data_admissao',
						currentFieldListCombined
					)
					this.resultadoOcrParsed.dataAdmissao = this.searchAndFillResults(
						this.resultadoOcrParsed.dataAdmissao,
						'periodo_inicio',
						currentFieldListCombined
					)

					//TODO: Criar um Types para tirar esse magic number
					if (hasHolerite) this.resultadoOcrParsed.tipoContratacao = '000' //ASSALARIADO

					this.resultadoOcrParsed.tipoContratacao = this.searchAndFillResults(
						this.resultadoOcrParsed.tipoContratacao,
						'tipo_contratacao',
						currentFieldListCombined
					)
					this.resultadoOcrParsed.rendaMensal = this.searchAndFillResults(
						this.resultadoOcrParsed.rendaMensal,
						'valor_liquido',
						currentFieldListCombined
					)
				} catch (error) {
					console.log('Erro ao preencher o objeto parsed com os resultados do ocr: ', error)
				}
			})

		this.resultadoOcrParsed.documentosList = this.tempFiles
			.filter((eachFile) => !eachFile.isUploaded && eachFile.file)
			.map((eachFile) => ({
				name: eachFile.fileName,
				file: eachFile.file,
				category: eachFile.tipo,
				type: getCategoriaDocumentoIdByTipo(eachFile.tipo),
				topic: StorageDocumentoTopicos.DOCUMENTO_PESSOAL,
				uploaded: false
			}))
	}

	searchAndFillResults(
		currentValue: any,
		fieldName: string,
		fieldList: Array<OCR.IField> | null | undefined,
		searchLike: boolean = false
	): any {
		if (currentValue) return currentValue

		if (!fieldList) return null

		let currentFieldSearch: OCR.IField | null | undefined

		//Buscar campos que contenham o texto
		if (searchLike) currentFieldSearch = fieldList.find((eachField) => eachField.name.includes(fieldName))
		else currentFieldSearch = fieldList.find((eachField) => eachField.name == fieldName)

		if (currentFieldSearch) return currentFieldSearch.value

		return null
	}

	getDocumentoPessoalName(tagList: Array<string> | null | undefined): string {
		if (!tagList || tagList.length == 0) return ''

		let countTag = 0
		let documentName = ''
		do {
			if (tagList[countTag] == 'rg') documentName = 'rg'

			if (tagList[countTag] == 'rne') documentName = 'rne'

			if (tagList[countTag].includes('cnh')) documentName = 'cnh'

			countTag++
		} while (countTag < tagList.length && !documentName)

		return documentName
	}

	fillDocumentoPessoalValue(tagList: Array<string> | null | undefined, fieldList: Array<OCR.IField> | null | undefined) {
		let documentoPessoalNome = this.getDocumentoPessoalName(tagList)

		//Procurar pelo documento especifico
		if (documentoPessoalNome) {
			switch (documentoPessoalNome) {
				case 'rg':
					this.resultadoOcrParsed.documentoNumero = this.searchAndFillResults(this.resultadoOcrParsed.documentoNumero, 'rg', fieldList)
					this.resultadoOcrParsed.documentoNumero = this.searchAndFillResults(this.resultadoOcrParsed.documentoNumero, 'doc', fieldList)

					if (this.resultadoOcrParsed.documentoNumero) this.resultadoOcrParsed.documentoTipo = 'RG'

					break

				case 'cnh':
					this.resultadoOcrParsed.documentoNumero = this.searchAndFillResults(this.resultadoOcrParsed.documentoNumero, 'cnh', fieldList)
					this.resultadoOcrParsed.documentoNumero = this.searchAndFillResults(this.resultadoOcrParsed.documentoNumero, 'doc', fieldList)

					if (this.resultadoOcrParsed.documentoNumero) this.resultadoOcrParsed.documentoTipo = 'CNH'
					break

				case 'rne':
					this.resultadoOcrParsed.documentoNumero = this.searchAndFillResults(this.resultadoOcrParsed.documentoNumero, 'rne', fieldList)
					this.resultadoOcrParsed.documentoNumero = this.searchAndFillResults(this.resultadoOcrParsed.documentoNumero, 'doc', fieldList)

					if (this.resultadoOcrParsed.documentoNumero) this.resultadoOcrParsed.documentoTipo = 'RNE'
					break
			}

			//Em alguns casos vem mais coisa alem do numero. Ex: 'numero algumacoisa'
			if (this.resultadoOcrParsed.documentoNumero?.includes(' '))
				this.resultadoOcrParsed.documentoNumero = this.resultadoOcrParsed.documentoNumero.split(' ')[0]
		}

		//Nao conseguiu preencher/encontrar o valor
		if (!this.resultadoOcrParsed.documentoNumero) {
			let listDocumentosBuscar: Array<string> = ['rg', 'cnh', 'rne']
			let countListaDocumentos = 0
			do {
				this.resultadoOcrParsed.documentoNumero = this.searchAndFillResults(
					this.resultadoOcrParsed.documentoNumero,
					listDocumentosBuscar[countListaDocumentos],
					fieldList
				)
				if (this.resultadoOcrParsed.documentoNumero)
					this.resultadoOcrParsed.documentoTipo = listDocumentosBuscar[countListaDocumentos].toUpperCase()

				countListaDocumentos++
			} while (countListaDocumentos < listDocumentosBuscar.length && !this.resultadoOcrParsed.documentoNumero)
		}

		//Tentar nos dois campos (vai ficar o que achar primeiro)
		this.resultadoOcrParsed.documentoDataEmissao = this.searchAndFillResults(
			this.resultadoOcrParsed.documentoDataEmissao,
			'data_emissao',
			fieldList
		)
		this.resultadoOcrParsed.documentoDataEmissao = this.searchAndFillResults(
			this.resultadoOcrParsed.documentoDataEmissao,
			'data_expedicao',
			fieldList
		)

		this.fillOrgaoExpedidorAndUF(fieldList)
	}

	fillOrgaoExpedidorAndUF(fieldList: Array<OCR.IField> | null | undefined) {
		//O documento e o estado vem juntos
		let orgaoExpedidor = this.searchAndFillResults(this.resultadoOcrParsed.documentoOrgaoExpedidor, 'orgao_expedidor', fieldList)
		if (orgaoExpedidor) {
			let orgaoExpedidorSplit = orgaoExpedidor.split(' ')
			if (orgaoExpedidorSplit.length > 0) {
				if (orgaoExpedidorSplit.length > 0 && orgaoExpedidorSplit[0])
					this.resultadoOcrParsed.documentoOrgaoExpedidor = orgaoExpedidor.split(' ')[0]
				if (orgaoExpedidorSplit.length > 1 && orgaoExpedidorSplit[1]) this.resultadoOcrParsed.documentoUF = orgaoExpedidor.split(' ')[1]
			} else this.resultadoOcrParsed.documentoOrgaoExpedidor = orgaoExpedidor
		}

		if (!this.resultadoOcrParsed.documentoOrgaoExpedidor)
			this.resultadoOcrParsed.documentoOrgaoExpedidor = this.searchAndFillResults(
				this.resultadoOcrParsed.documentoOrgaoExpedidor,
				'orgao_emissor',
				fieldList
			)

		if (!this.resultadoOcrParsed.documentoUF)
			this.resultadoOcrParsed.documentoUF = this.searchAndFillResults(this.resultadoOcrParsed.documentoUF, 'estado_emissor', fieldList)
	}

	fillNumeroCasa(fieldList: Array<OCR.IField> | null | undefined) {
		//A maioria das vezes, nao vem o numero da casa separado, somente embutido no endereco
		//Tentar pegar separado, se nao, tentar pegar do endereco
		let enderecoNumero = this.searchAndFillResults(this.resultadoOcrParsed.enderecoNumero, 'cep_numero', fieldList, true)
		if (!enderecoNumero) {
			try {
				//Tento pegar o campo de endereco, se existir
				let enderecoCompleto = this.searchAndFillResults(this.resultadoOcrParsed.enderecoNumero, 'endereco', fieldList, true)
				if (enderecoCompleto) {
					//O endereco normalmente vem quebrado em linhas, pegar a primeira (que é onde fica a rua + numero)
					enderecoCompleto = enderecoCompleto.split('\n')[0]

					//Separar a primeira linha do endereco por espaços, o ultimo deveria ser o numero
					let enderecoCompletoSplit = enderecoCompleto.split(' ')
					if (enderecoCompletoSplit.length > 1) {
						//Se for numero, atribuo
						if (!isNaN(enderecoCompletoSplit[enderecoCompletoSplit.length - 1])) {
							this.resultadoOcrParsed.enderecoNumero = enderecoCompletoSplit[enderecoCompletoSplit.length - 1]
						}
					}
				}
			} catch (error) {
				console.log('Erro ao pegar o numero da residência: ', error)
			}
		}
	}

	getDocumentName(document: IDocumentos.IDocumentoListItem) {
		if (document.fileName) return document.fileName

		if (document.file) return document.file.name

		return ''
	}
}
